"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentOrderLabelDocumentType = exports.OrderUpdateType = exports.OrderItemChangeType = exports.ShippingMethod = exports.OrderStatus = exports.OrderSource = exports.OrderType = exports.OrderPaymentType = exports.OrderPaymentStatus = void 0;
var OrderPaymentStatus;
(function (OrderPaymentStatus) {
    OrderPaymentStatus["Approved"] = "APPROVED";
    OrderPaymentStatus["Authorized"] = "AUTHORIZED";
    OrderPaymentStatus["Cancelled"] = "CANCELLED";
    OrderPaymentStatus["ChargedBack"] = "CHARGED_BACK";
    OrderPaymentStatus["InMediation"] = "IN_MEDIATION";
    OrderPaymentStatus["InProcess"] = "IN_PROCESS";
    OrderPaymentStatus["Pending"] = "PENDING";
    OrderPaymentStatus["Refunded"] = "REFUNDED";
    OrderPaymentStatus["Rejected"] = "REJECTED";
})(OrderPaymentStatus || (exports.OrderPaymentStatus = OrderPaymentStatus = {}));
var OrderPaymentType;
(function (OrderPaymentType) {
    OrderPaymentType["AccountMoney"] = "ACCOUNT_MONEY";
    OrderPaymentType["ATM"] = "ATM";
    OrderPaymentType["BankTransfer"] = "BANK_TRANSFER";
    OrderPaymentType["CreditCard"] = "CREDIT_CARD";
    OrderPaymentType["DebitCard"] = "DEBIT_CARD";
    OrderPaymentType["PayPal"] = "PAYPAL";
    OrderPaymentType["PrepaidCard"] = "PREPAID_CARD";
    OrderPaymentType["Ticket"] = "TICKET";
    OrderPaymentType["PaymentLink"] = "PAYMENT_LINK";
    OrderPaymentType["Cash"] = "CASH";
    OrderPaymentType["Pix"] = "PIX";
    OrderPaymentType["Boleto"] = "BOLETO";
    /**
     * This property means that the seller has not specified any payment method and the buyer must contact the seller to arrange an option.
     */
    OrderPaymentType["NotSpecified"] = "NOT_SPECIFIED";
})(OrderPaymentType || (exports.OrderPaymentType = OrderPaymentType = {}));
var OrderType;
(function (OrderType) {
    OrderType["Standard"] = "STANDARD";
    OrderType["Preorder"] = "PREORDER";
})(OrderType || (exports.OrderType = OrderType = {}));
var OrderSource;
(function (OrderSource) {
    OrderSource["Channel"] = "CHANNEL";
    OrderSource["RediRedi"] = "REDIREDI";
})(OrderSource || (exports.OrderSource = OrderSource = {}));
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["Authorized"] = "AUTHORIZED";
    OrderStatus["Canceled"] = "CANCELLED";
    OrderStatus["Cancelling"] = "CANCELLING";
    OrderStatus["Completed"] = "COMPLETED";
    OrderStatus["Invalid"] = "INVALID";
    OrderStatus["PartiallyPaid"] = "PARTIALLY_PAID";
    OrderStatus["PartiallyRefunded"] = "PARTIALLY_REFUNDED";
    OrderStatus["PartiallyShipped"] = "PARTIALLY_SHIPPED";
    OrderStatus["PaymentFailed"] = "PAYMENT_FAILED";
    OrderStatus["PendingAvailability"] = "PENDING_AVAILABILITY";
    OrderStatus["PendingCancellation"] = "PENDING_CANCELLATION";
    OrderStatus["PendingPayment"] = "PENDING_PAYMENT";
    OrderStatus["ProcessingPayment"] = "PROCESSING_PAYMENT";
    OrderStatus["ReadyToShip"] = "READY_TO_SHIP";
    OrderStatus["Refunded"] = "REFUNDED";
    OrderStatus["Refunding"] = "REFUNDING";
    OrderStatus["RetryToShip"] = "RETRY_TO_SHIP";
    OrderStatus["Shipped"] = "SHIPPED";
    OrderStatus["Shipping"] = "SHIPPING";
    OrderStatus["Unfulfilled"] = "UNFULFILLED";
    OrderStatus["Unshipped"] = "UNSHIPPED";
})(OrderStatus || (exports.OrderStatus = OrderStatus = {}));
var ShippingMethod;
(function (ShippingMethod) {
    ShippingMethod["Correios"] = "CORREIOS";
    ShippingMethod["Delivery"] = "DELIVERY";
    ShippingMethod["Others"] = "OTHERS";
    ShippingMethod["Pickup"] = "PICKUP";
    ShippingMethod["Digital"] = "DIGITAL";
    ShippingMethod["Room"] = "ROOM";
    ShippingMethod["ToBeArranged"] = "TO_BE_ARRANGED";
})(ShippingMethod || (exports.ShippingMethod = ShippingMethod = {}));
var OrderItemChangeType;
(function (OrderItemChangeType) {
    OrderItemChangeType["Added"] = "ADDED";
    OrderItemChangeType["Changed"] = "CHANGED";
    OrderItemChangeType["NotChanged"] = "NOT_CHANGED";
    OrderItemChangeType["Removed"] = "REMOVED";
})(OrderItemChangeType || (exports.OrderItemChangeType = OrderItemChangeType = {}));
var OrderUpdateType;
(function (OrderUpdateType) {
    OrderUpdateType["ItemChanged"] = "ITEM_CHANGED";
    OrderUpdateType["StatusChanged"] = "STATUS_CHANGED";
})(OrderUpdateType || (exports.OrderUpdateType = OrderUpdateType = {}));
var ShipmentOrderLabelDocumentType;
(function (ShipmentOrderLabelDocumentType) {
    ShipmentOrderLabelDocumentType["Label"] = "LABEL";
    ShipmentOrderLabelDocumentType["PackSlip"] = "PACK_SLIP";
    ShipmentOrderLabelDocumentType["LabelAndPackSlip"] = "LABEL_AND_PACK_SLIP";
})(ShipmentOrderLabelDocumentType || (exports.ShipmentOrderLabelDocumentType = ShipmentOrderLabelDocumentType = {}));
//# sourceMappingURL=order.js.map